import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';
import {MechanicalReplacementServiceIntervals} from '../../types/RentalVehicle';

export interface FormCalculateNextReplacementDateIntervalAction {
  form: UseFormReturn<BaseVehicle>;
  name: MechanicalReplacementServiceIntervals;
  value: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next replacement date for a vehicle component.
 * Uses the last replacement date and replacement interval in months to calculate the next date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and component name
 */
export const formCalculateNextReplacementDateIntervalAction = (
  _context: unknown,
  params: FormCalculateNextReplacementDateIntervalAction
): void => {
  const {form, name, value} = params;

  const lastReplacementDate = form.getValues(`serviceIntervals.${name}.lastReplacementDate`);
  const replacementAfterMonths = value;

  if (!lastReplacementDate || !replacementAfterMonths) {
    return;
  }

  const nextDate = addMonths(parseDate(lastReplacementDate), replacementAfterMonths);

  form.setValue(
    `serviceIntervals.${name}.nextReplacementDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
